export const state = {
    statusModal: false
}

export const mutations = {
    UPDATE_STATUS(state, payload) {
        state.statusModal = payload
    } 
}

export const actions = {
    updateStatusModal({ commit }, payload) {
        commit('UPDATE_STATUS', payload)
    }
}